module.exports = __webpack_public_path__ + "img/attention.1924a742.png";